// Copyright © 2021 Move Closer
import { abstractPaginationProps } from '../../_abstract';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const bootstrapPaginationProps = {
    ...abstractPaginationProps,
    link: {
        type: Object,
        required: false
    }
};
